<template>
  <aside v-if="notice" class="automatic-rule-notice" role="status">
    <div><strong>Your lead rules are ready</strong><p>We’ve set up your survey and High Value rules. Review them and change anything you’d like.</p><small v-if="notice.sources.length">Based on: {{ notice.sources.join(' · ') }}</small><p v-if="error">{{ error }}</p></div>
    <div class="notice-actions"><router-link to="/settings?section=lead-rules">Review rules</router-link><button v-if="canDismiss" type="button" :disabled="busy" @click="dismiss">Got it</button></div>
  </aside>
</template>
<script>
import axios from 'axios'
export default {
  name: 'AutomaticLeadRulesNotice',
  data: () => ({ notice: null, busy: false, error: '' }),
  computed: {
    me () { return this.$store.state.me.me },
    canDismiss () { const profile = this.$store.state.me.profile; return this.me && (this.me.settings || {}).role !== 'Manager (readonly)' && (!profile || (profile.settings || {}).role !== 'Manager (readonly)') }
  },
  watch: { 'me.id': { immediate: true, handler () { this.load() } } },
  methods: {
    options () { return { headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt }, timeout: 15000 } },
    async load () {
      this.notice = null
      if (!this.me || !['business', 'location'].includes(this.me.company_type)) return
      const id = this.me.id
      try { const { data } = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/onboarding/journey/${id}/rule-setup`, this.options()); if (this.me && this.me.id === id) this.notice = data.notice } catch (e) { /* A notice must not block the workspace. */ }
    },
    async dismiss () {
      if (this.busy) return
      this.busy = true; this.error = ''; const id = this.me.id
      try { await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/onboarding/journey/${id}/rule-setup/read`, {}, this.options()); if (this.me && this.me.id === id) this.notice = null } catch (e) { this.error = 'Could not dismiss this message. Please try again.' } finally { this.busy = false }
    }
  }
}
</script>
<style scoped>
.automatic-rule-notice{display:flex;align-items:center;justify-content:space-between;gap:20px;margin:18px 24px;padding:18px 22px;background:#f0f8fa;border:1px solid #cfe5e9;border-radius:12px;color:#16283c;font-size:13px}.automatic-rule-notice p{margin:5px 0;line-height:1.5}.automatic-rule-notice small{color:#5b6b7c;overflow-wrap:anywhere}.notice-actions{display:flex;align-items:center;gap:14px;flex-shrink:0}.notice-actions a{background:#1f7f8f;color:#fff!important;padding:10px 15px;border-radius:8px;text-decoration:none}.notice-actions button{color:#42556a;padding:10px;background:transparent}.notice-actions button:disabled{opacity:.5}@media(max-width:700px){.automatic-rule-notice{align-items:flex-start;flex-direction:column}}
</style>
